import { AgedType } from "../../types"

type Summary = {
  balance: number
  "7_day": number
  "15_day": number
  "21_day": number
  "30_day": number
  "60_day": number
}

export const calculateSummary = (data: AgedType[]): Summary => {
  return data.reduce((acc, val) => {
    const balance: number = val?.balance ?? 0
    const total: number = val?.total_amount ?? 0

    if (val?.aged_receivable <= 7) {
      return {
        ...acc,
        balance: acc.balance + total,
        "7_day": acc["7_day"] + balance
      }
    } else if (val?.aged_receivable >= 8 && val?.aged_receivable <= 15) {
      return {
        ...acc,
        balance: acc.balance + total,
        "15_day": acc["15_day"] + balance
      }
    } else if (val?.aged_receivable >= 16 && val?.aged_receivable <= 21) {
      return {
        ...acc,
        balance: acc.balance + total,
        "21_day": acc["21_day"] + balance
      }
    } else if (val?.aged_receivable >= 22 && val?.aged_receivable <= 30) {
      return {
        ...acc,
        balance: acc.balance + total,
        "30_day": acc["30_day"] + balance
      }
    } else if (val?.aged_receivable >= 31) {
      return {
        ...acc,
        balance: acc.balance + val?.balance,
        "60_day": acc["60_day"] + val?.balance
      }
    }

    return acc
  }, {
    balance: 0,
    "7_day": 0,
    "15_day": 0,
    "21_day": 0,
    "30_day": 0,
    "60_day": 0
  })
}